import ReportLandScape from './reportLandScape'

export default ReportLandScape
